/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Auth_Title4Inputs */

const en_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth that clients trust`)
};

const ar_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مصادقة يثق بها العملاء`)
};

const bn_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্লায়েন্টদের বিশ্বস্ত অথ`)
};

const de_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth, der Clients vertrauen`)
};

const es_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticación en la que confían los clientes`)
};

const fr_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une authentification digne de confiance`)
};

const pt_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticação em que os clientes confiam`)
};

const zh_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客户端信得过的认证`)
};

const tr_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstemcilerin güvendiği kimlik doğrulama`)
};

const ru_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Авторизация, которой доверяют клиенты`)
};

const pl_svc_mcp_server_development_auth_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uwierzytelnianie godne zaufania`)
};

/**
* | output |
* | --- |
* | "Auth that clients trust" |
*
* @param {Svc_Mcp_Server_Development_Auth_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_auth_title4 = /** @type {((inputs?: Svc_Mcp_Server_Development_Auth_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Auth_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_auth_title4(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_auth_title4(inputs)
	if (locale === "de") return de_svc_mcp_server_development_auth_title4(inputs)
	if (locale === "es") return es_svc_mcp_server_development_auth_title4(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_auth_title4(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_auth_title4(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_auth_title4(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_auth_title4(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_auth_title4(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_auth_title4(inputs)
	return en_svc_mcp_server_development_auth_title4(inputs)
});
export { svc_mcp_server_development_auth_title4 as "svc_mcp-server-development_AUTH_title" }